import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Grid, TextField, Button } from "@material-ui/core";
import axios from "axios";

const CreateMeme = () => {
  const location = useLocation();
  const currentMeme = location.state.meme;
  const [fields, setFields] = useState([{ value: null }]);
  const [responseUrl, setResponseUrl] = useState();
  function handleChange(i, event) {
    const values = [...fields];
    values[i].value = event.target.value;
    setFields(values);
  }

  const handleAdd = () => {
    const values = [...fields];
    values.push({ value: null });
    setFields(values);
  };

  function handleRemove(i) {
    const values = [...fields];
    values.splice(i, 1);
    setFields(values);
  }

  const handleSubmit = () => {
    var bodyFormData = new FormData();
    console.log(process.env.USER_NAME);
    bodyFormData.set("username", "rohithgilla");
    bodyFormData.set("password", "8790089990");
    bodyFormData.set("template_id", currentMeme.id);
    for (let index = 0; index < currentMeme.box_count; index++) {
      bodyFormData.set(`boxes[${index}][text]`, fields[index].value);
    }
    console.log(bodyFormData);
    axios({
      method: "post",
      url: "https://api.imgflip.com/caption_image",
      data: bodyFormData,
      headers: { "Content-Type": "multipart/form-data" }
    })
      .then(function(response) {
        setResponseUrl(response.data.data.url);
        console.log(response);
      })
      .catch(function(response) {
        //handle error
        console.log(response);
      });
  };

  return (
    <>
      <Grid container>
        <Grid item xs={6}>
          {responseUrl === undefined ? (
            <img
              src={currentMeme.url}
              style={{ height: "auto", width: "450px" }}
              alt="meme"
            />
          ) : (
            <img
              src={responseUrl}
              style={{ height: "450px", width: "auto" }}
              alt="meme"
            />
          )}
        </Grid>
        <Grid item xs={6}>
          <h4>
            Add {currentMeme.box_count} number of boxes by cliking on plus
            button.
          </h4>
          <Button variant="outlined" onClick={() => handleAdd()}>
            +
          </Button>
          {fields.map((field, idx) => {
            return (
              <div key={`${field}-${idx}`}>
                <TextField
                  label="Enter text"
                  value={field.value}
                  onChange={e => handleChange(idx, e)}
                />
                {console.log(fields)}
                <Button variant="outlined" onClick={() => handleRemove(idx)}>
                  x
                </Button>
                ;
              </div>
            );
          })}
          <Button variant="outlined" color="secondary" onClick={handleSubmit}>
            Generate Meme
          </Button>
        </Grid>
      </Grid>
    </>
  );
};

export default CreateMeme;
